<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import CreateIssue from './CreateIssue.vue';

const props = defineProps({
  accountId: {
    type: [Number, String],
    required: true,
  },
  conversation: {
    type: Object,
    required: true,
  },
  integrationId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const title = computed(() => {
  const { meta: { sender: { name = null } = {} } = {} } = props.conversation;
  return t('INTEGRATION_SETTINGS.LINEAR.LINK.LINK_TITLE', {
    conversationId: props.conversation.id,
    name,
  });
});

const contact = computed(() => {
  const {
    meta: {
      sender: { phone_number = null, email = null, name = null } = {},
    } = {},
  } = props.conversation;
  return {
    phone: phone_number ? phone_number.replace(/\D/g, '') : null,
    email,
    name,
  };
});

const onClose = () => {
  emit('close');
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      class="pb-4"
      header-title="Cadastro de Negociações"
      header-content=""
    />

    <div class="flex flex-col h-auto overflow-auto">
      <div class="flex flex-col px-8 pb-4">
        <CreateIssue
          :account-id="accountId"
          :conversation-id="conversation.id"
          :title="title"
          :contact="contact"
          :integration-id="integrationId"
          @close="onClose"
          @submit="onClose"
        />
      </div>
    </div>
  </div>
</template>
